export default function setCookie(name, value, options = {}) {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (options.expires) {
        const date = new Date(options.expires);
        cookieString += `; expires=${date.toUTCString()}`;
    }

    if (options.path) {
        cookieString += `; path=${options.path}`;
    }

    if (options.secure) {
        cookieString += `; secure`;
    }

    if (options.httponly) {
        // HttpOnly cookies cannot be set via JavaScript, so this option is ignored
        console.warn('HttpOnly cookies cannot be set via JavaScript');
    }

    if (options.samesite) {
        cookieString += `; samesite=${options.samesite}`;
    }

    document.cookie = cookieString;
}
